import { atom } from "jotai";
import {atomWithReset } from "jotai/utils"

export const usersState = atom([]);
export const conditionsState = atom([]);
export const conditionFeaturesState = atom([]);
export const conditionTreatmentsState = atom([]);
export const conditionInvestigationsState = atom([]);
export const conditionPatientInfoState = atom(null);
export const parentConditionsState = atom([]);

export const cpdContentCoursesState = atom([]);
export const cpdContentCourseState = atom([]);
export const cpdContentCoursesCount = atom((get) => {
  const courses = get(cpdContentCoursesState);
  return Array.isArray(courses) ? courses.length : 0;
});

export const cpdContentCourseQuizesState = atom([]);
export const cpdContentCourseQuizState = atom({});

export const cpdContentConditionsState = atom([]);
export const cpdContentConditionState = atom([]);
export const cpdContentNodesState = atom([]);
export const cpdContentNodeState = atom(null);
export const cpdContentSubSectionNodesState = atom([]);
export const cpdContentSubSectionNodeState = atom(null);
export const cpdContentNodeTablesState = atom([]);
export const cpdContentNodeQuizState = atom([]);
export const cpdContentNodeCount = atom((get) => {
  const nodes = get(cpdContentNodesState);
  return Array.isArray(nodes) ? nodes.length : 0;
});

export const cpdContentQuizState = atom(null);

export const cpdContentCasesState = atom([]);
export const cpdContentCaseState = atom([]);
export const cpdContentCaseCount = atom((get) => {
  const nodes = get(cpdContentCasesState);
  return Array.isArray(nodes) ? nodes.length : 0;
});
export const cpdContentCaseSearchText = atom("");
export const cpdContentCasesFilterState = atomWithReset({
  searchText: "",
  selectedCases: [],
});

export const currentConditionState = atom(null);

export const conditionsCountState = atom((get) => {
  const conditions = get(conditionsState);

  return Array.isArray(conditions) ? conditions.length : 0;
});

export const parentConditionsCountState = atom((get) => {
  const parentConditions = get(parentConditionsState);

  return Array.isArray(parentConditions) ? parentConditions.length : 0;
});

export const conditionFeaturesCountState = atom((get) => {
  const features = get(conditionFeaturesState);
  return Array.isArray(features) ? features.length : 0;
});

export const conditionTreatmentsCountState = atom((get) => {
  const treatments = get(conditionTreatmentsState);
  return Array.isArray(treatments) ? treatments.length : 0;
});

export const conditionInvestigationsCountState = atom((get) => {
  const investigations = get(conditionInvestigationsState);
  return Array.isArray(investigations) ? investigations.length : 0;
});

export const currentUserState = atom(null);

const StorageStateKeys = {
  users: {
    ALL: usersState,
    ONE: currentUserState,
    COUNT: null,
  },
  cases: {
    ALL: cpdContentCasesState,
    ONE: cpdContentCaseState,
    COUNT: cpdContentCaseCount,
  },
  nodes: {
    ALL: cpdContentNodesState,
    ONE: cpdContentNodeState,
    COUNT: cpdContentNodeCount,
  },
  conditions: {
    ALL: cpdContentConditionsState,
    ONE: cpdContentConditionState,
    COUNT: null,
  },
  guidelines: {
    ALL: cpdContentConditionsState,
    ONE: cpdContentConditionState,
    COUNT: null,
  },
  courses: {
    ALL: cpdContentCoursesState,
    ONE: cpdContentCourseState,
    COUNT: cpdContentCoursesCount,
  },
};

export default StorageStateKeys;
export * from "./derived/"